import { LitEntity, html } from '../../utility/lit-entity';
import '../../common/bn-placeholder';
import '../../bins/parts/bin-path-name';

class OrderPathName extends LitEntity {
  render() {
    return html`
      <bin-path-name href="${this.getHref('https://api.binsentry.com/rel/bin')}"></bin-path-name>
    `;
  }
}

window.customElements.define('order-path-name', OrderPathName);
